import React from 'react';

const Mastercard = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={60} height={40} fill="none" {...props}>
    <path fill="#F7F7F7" d="M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z" />
    <path fill="#FF5F00" d="m36.26 8.16-12.91.044.39 23.637 12.912-.044-.392-23.638Z" />
    <path
      fill="#EB001B"
      d="M24.198 20.07c-.08-4.807 2.074-9.08 5.448-11.85-2.547-1.998-5.739-3.2-9.2-3.188-8.197.028-14.717 6.782-14.58 15.101.14 8.32 6.883 15.027 15.081 15a14.43 14.43 0 0 0 9.092-3.251c-3.465-2.706-5.76-7.004-5.84-11.812Z"
    />
    <path
      fill="#F79E1B"
      d="M54.133 19.868c.139 8.32-6.382 15.073-14.58 15.1-3.46.013-6.652-1.189-9.199-3.187 3.415-2.77 5.527-7.043 5.447-11.85a15.396 15.396 0 0 0-5.84-11.812 14.43 14.43 0 0 1 9.092-3.25c8.198-.028 14.943 6.722 15.08 14.999Z"
    />
  </svg>
);

export default Mastercard;
